
import EventCardGeneral from '@/components/EventCardGeneral.vue';
import ShimmerEffect from "@/components/ShimmerEffect.vue";
export default {
  components: {
    EventCardGeneral,
    ShimmerEffect
  },
  head() {
    return {
      title: this.title,
      meta: [{
        hid: "description",
        name: "description",
        content: this.description,
      },
      {
        hid: "keywords",
        name: "keywords",
        content: 'Events in ' + this.$route.params.state + ', events in ' + this.$route.params.state + ' today, upcoming events in ' + this.$route.params.state + ', events in ' + this.$route.params.state + ' this weekend, events in ' + this.$route.params.state + ' this week, music events in ' + this.$route.params.state + ' today, party events in ' + this.$route.params.state + ' today, party events in ' + this.$route.params.state + ', events in ' + this.$route.params.state + ' tomorrow'
      },
      {
        hid: "og:title",
        property: "og:title",
        content: this.title,
      },
      {
        hid: "og:description",
        property: "og:description",
        content: this.description,
      },
      {
        hid: "twitter:title",
        property: "twitter:title",
        content: this.title,
      },
      {
        hid: "twitter:description",
        property: "twitter:description",
        content: this.description,
      },

      ],
      bodyAttrs: {
        class: this.showHelpModal ? 'pass-modal-open' : ''
      }
    };

  },
  data() {
    return {
      title: 'Events in ' + this.$route.params.state + ' - Events in ' + this.$route.params.state + ' today | upcoming events in ' + this.$route.params.state,
      description: 'Events in ' + this.$route.params.state + ', events in ' + this.$route.params.state + ' today, upcoming events in ' + this.$route.params.state + ', events in ' + this.$route.params.state + ' this weekend, events in ' + this.$route.params.state + ' this week, music events in ' + this.$route.params.state + ' today, party events in ' + this.$route.params.state + ' today, party events in ' + this.$route.params.state + ', events in ' + this.$route.params.state + ' tomorrow',
      categoriesData: null,
      skip: 0,
      page: 1,
      totalNumberOfpages: 0,
      busy: false,
      productObj: [],
      listings: {},
      schemaData: [],
      loading: true,
      listingLoading: true,
      eventCategoryModal: false,

      //New code
      stateSlug: null,
      selectedState: null,
      activiteStatesList: [],
      popularEvents: null,
      popularEventsLoading: true,
      bestEventsLoading: true,
      categoriesLoading: true,
      bestEvents: null,

    }
  },

  async validate({
    params,
    store
  }) {
    // await operations
    if (params.slug != (null || "")) {
      this.stateSlug = params.state;
      this.selectedState = params.state;
      return true // if the params are valid
    } else {
      return false // will stop Nuxt.js to render the route and display the error page
    }
  },
  created() {
    this.stateSlug = this.$route.params.state;
    this.selectedState = this.stateSlug
  },

  mounted() {
    this.getData();
    let pagination = (this.page - 1) * 8;
    if (pagination < 0) {
      pagination = 0;
    }
    this.getListings(pagination);
  },

  methods: {
    async getData() {
      this.categoriesData = await fetch(this.$config.fetchUrl + '/api/activityTypes/app/getTypeDetails/events/')
        .then(res => res.text());
      this.categoriesData = this.getCryptKey(this.categoriesData);
      this.categoriesLoading = false;
      this.activiteStatesList = await fetch(this.$config.fetchUrl + '/api/states/app/getAllActiveStates/')
        .then(res => res.text());
      this.activiteStatesList = this.getCryptKey(this.activiteStatesList);
      this.popularEvents = await fetch(this.$config.fetchUrl + '/api/events/getFeaturedEventsInCity/' + this.stateSlug)
        .then(res => res.text());
      this.popularEvents = this.getCryptKey(this.popularEvents);
      this.popularEventsLoading = false
      this.bestEvents = await fetch(this.$config.fetchUrl + '/api/events/getPopularEventsInCity/' + this.stateSlug)
        .then(res => res.text());
      this.bestEvents = this.getCryptKey(this.bestEvents);
      this.bestEventsLoading = false
    },

    cityDropdownClicked(event) {
      if (event && event.target.value) {
        this.$router.push({
          path: `/${event.target.value}/events/`
        })
      }
    },
    eventDay(day) {
      switch (day) {
        case 'today':
          this.$router.push({
            path: `/${this.stateSlug}/events-today`
          })
          break;
        case 'tomorrow':
          this.$router.push({
            path: `/${this.stateSlug}/events-tomorrow`
          })
          break;
        case 'weekend':
          this.$router.push({
            path: `/${this.stateSlug}/events-weekend`
          })
          break;
        default:
          this.$router.push({
            path: `/${this.stateSlug}/events-today`
          })
          break;
      }
    },
    categoryBtnClicked(item) {
      if (item && item.slug) {
        this.$router.push({
          path: `/${this.stateSlug}/events/${item.slug}-events`
        })
      }
    },

    getStateTitle(title) {
      if (this.activiteStatesList && this.activiteStatesList.states) {
        var stateTitle = this.activiteStatesList.states.filter(x => x.slug == title);
        return stateTitle && stateTitle.length > 0 ? stateTitle[0].name : '';
      }
      return ''
    },

    loadMore() {
      this.busy = false;
      if (this.listings.isMoreDataAvailable) {
        this.busy = true;
        setTimeout(() => {
          this.page++
          this.callback(this.page)
        }, 1000);
      }
    },

    // callback for the pagination plugin
    callback: function (page) {
      this.page = page;
      let pagination = (page - 1) * 8;
      if (pagination < 0) {
        pagination = 0;
      }
      this.getListings(pagination);
    },

    // TO get SUBSCRIPTIONS using pagination
    getListings(skip, year = null, month = null, categories = null, queryStr = null) {
      //if no categories are selected we can mkae a get request of the form /api/posts/app/getPostsOfType/places/:query/:pagination/:categories/:sortBy
      //the reason is POST requests cant be cached but get requests can so the data will load very fast when user hits back from a detail page
      //this.listingLoading = true;

      // AXIOS api call to add review api
      this.$axios
        .get(
          `/api/events/getAllUpcomingEventsInCity/${this.stateSlug}/${skip}`
        )
        .then((response) => {
          let value = this.getCryptKey(response.data);
          this.productObj.push(...value.events)
          this.listings = value;
          this.schemaData = this.listings && this.listings.events ? this.listings.events : [];
          if (skip == 0) {
            this.page = 1;

          }
          this.totalNumberOfpages = Math.ceil(this.listings.totalCount / 12);
          this.$nextTick(() => {
            this.busy = false;
            this.listingLoading = false;
          });
        })
        .catch((error) => {
          this.$nextTick(() => {
            this.listingLoading = false;
          });
        })
        .finally(() => {
          this.$nextTick(() => {
            this.listingLoading = false;
          });
        });
    }

  }

}
